import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const accommodationCapacitySettingsEntity: Entity = {
  model: model,
  repository: repository,
}

export default accommodationCapacitySettingsEntity
